import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';
import classnames from 'classnames';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Icons
import { NumberOne, NumberTwo, Check, NoMatch } from '../../../icons';

// Styles
import styles from './stepsSection.module.scss';

const cx = classnames.bind(styles);

const StepsSection = ({
  companyColor,
  textColor,
  isButtonDisabled,
  onNextStepClick,
}) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  return (
    <section id="steps-section" className={styles.container}>
      <h2 className={styles.heading}>
        {t(`description_page.steps_section.title.${approach}`)}
      </h2>
      <div className={styles.steps}>
        <div
          className={cx(
            styles.step,
            { [styles.clickable]: !isButtonDisabled },
            'interested-btn',
          )}
          onClick={onNextStepClick}
        >
          <div className={styles.stepBulletpoint}>
            <div
              className={styles.circle}
              style={{
                backgroundColor: companyColor,
              }}
            >
              <span className={cx(styles.iconWrapper, styles.responsive)}>
                <NumberOne fill={textColor} className={styles.icon} />
              </span>
            </div>
          </div>
          <div className={styles.stepContent}>
            <h3 className={styles.stepName}>
              {t(
                `description_page.steps_section.interested_step.title.${approach}`,
              )}
            </h3>
            <p className={styles.stepDescription}>
              {t(
                `description_page.steps_section.interested_step.description.${approach}`,
              )}
            </p>
          </div>
        </div>

        <div
          className={cx(
            styles.step,
            styles.highlighted,
            { [styles.clickable]: !isButtonDisabled },
            'interested-btn',
          )}
          onClick={onNextStepClick}
        >
          <div className={styles.stepBulletpoint}>
            <div
              className={cx(styles.circle, styles.elevated)}
              style={{
                border: `1.5px solid ${companyColor}`,
              }}
            >
              <span className={styles.iconWrapper}>
                <NumberTwo fill={companyColor} className={styles.icon} />
              </span>
            </div>
          </div>
          <div className={styles.stepContent}>
            <h3 className={styles.stepName}>
              {t(
                `description_page.steps_section.schedule_call_step.title.${approach}`,
              )}
            </h3>
            <p className={styles.stepDescription}>
              {t(
                `description_page.steps_section.schedule_call_step.description.${approach}`,
              )}
            </p>
          </div>
        </div>

        <div className={styles.step}>
          <div className={styles.stepBulletpoint}>
            <div
              className={cx(styles.circle, styles.elevated)}
              style={{
                border: `1.5px solid ${companyColor}`,
              }}
            >
              <span className={styles.iconWrapper}>
                <Check fill={companyColor} className={styles.icon} />
              </span>
            </div>
          </div>
          <div className={styles.stepContent}>
            <h3 className={styles.stepName}>
              {t(`description_page.steps_section.match_step.title.${approach}`)}
            </h3>
            <p className={styles.stepDescription}>
              {t(
                `description_page.steps_section.match_step.description.${approach}`,
              )}
            </p>
          </div>
        </div>

        <div className={styles.step}>
          <div className={styles.stepBulletpoint}>
            <div
              className={cx(styles.circle, styles.elevated)}
              style={{
                border: `1.5px solid ${companyColor}`,
              }}
            >
              <span className={styles.iconWrapper}>
                <NoMatch fill={companyColor} className={styles.icon} />
              </span>
            </div>
          </div>
          <div className={styles.stepContent}>
            <h3 className={styles.stepName}>
              {t(
                `description_page.steps_section.no_match_step.title.${approach}`,
              )}
            </h3>
            <p className={styles.stepDescription}>
              {t(
                `description_page.steps_section.no_match_step.description.${approach}`,
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

StepsSection.propTypes = {
  textColor: PropTypes.string.isRequired,
  companyColor: PropTypes.string.isRequired,
  isButtonDisabled: PropTypes.bool.isRequired,
  onNextStepClick: PropTypes.func.isRequired,
};

export default StepsSection;
